import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  noOfStructure: 0,
};

export const irradianceInfo = createSlice({
  name: "irradianceInfo",
  initialState: initialState,
  reducers: {
    updateIrradianceInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateIrradianceInfo } = irradianceInfo.actions;

export default irradianceInfo.reducer;

export const elevationAngle = {
  jan: 0.5773,
  feb: 0.8391,
  mar: 1.1918,
  apr: 1.7321,
  may: 2.7475,
  jun: 3.7321,
  jul: 3.7321,
  aug: 2.7475,
  sep: 1.7321,
  oct: 1.1918,
  nov: 0.8391,
  dec: 0.5773,
};

export const pvPerformance = 0.18;

export const weatherStation = [
  "Select Weather Station",
  "Lahore",
  "Karachi",
  "Islamabad",
  "Multan",
  "Bahawalpur",
  "Faisalabad",
  "Hyderabad",
  "Gujranwala",
  "Jhang",
  "Rahim_Yar_Khan",
  "Sialkot",
  "Muzaffarabad",
  "Quetta",
  "Rawalpindi",
  "Azad_Kashmir",
  "Peshawar",
  "Sahiwal",
  "Gujrat",
  "Bahawalnagar",
  "Sukkur",
  "Gilgit",
  "Sargodha",
  "Dera Ghazi Khan",
  "Mardan",
  "Okara",
  "Chiniot",
  "Abbottabad",
  "Attock",
  "Bhakkar",
];

export const IRRADIANCEDATA = {
  Lahore: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Karachi: {
    jan: 731.99,
    feb: 868.11,
    mar: 1117.44,
    apr: 1226.24,
    may: 1291.72,
    jun: 1194.94,
    jul: 753.99,
    aug: 824.5,
    sep: 980.26,
    oct: 984.33,
    nov: 818.22,
    dec: 734.22,
  },
  Islamabad: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Multan: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Bahawalpur: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Faisalabad: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Hyderabad: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Gujranwala: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Jhang: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Rahim_Yar_Khan: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Sialkot: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Muzaffarabad: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Quetta: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Rawalpindi: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Azad_Kashmir: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Peshawar: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Sahiwal: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Gujrat: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Bahawalnagar: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Sukkur: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Gilgit: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Sargodha: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Dera_Gazi_Khan: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Mardan: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Okara: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Chiniot: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Abbottabad: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Attock: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
  Bhakkar: {
    jan: 428.98,
    feb: 589.37,
    mar: 831.98,
    apr: 1006.63,
    may: 1184.96,
    jun: 1160.89,
    jul: 904.44,
    aug: 954.16,
    sep: 889.66,
    oct: 783.51,
    nov: 536.5,
    dec: 518.54,
  },
};
